import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";
import { ScrollText, Gavel, Clock } from "lucide-react";

/**
 * Blocco consensi CONTRATTUALI per il checkout della consulenza a pagamento.
 *
 * Contiene 3 sottoscrizioni richieste dal Codice del Consumo (D.Lgs. 206/2005):
 *  1. Accettazione Termini e Condizioni (art. 1341 c.c. — pulsante "consenso contratto")
 *  2. Approvazione specifica clausole vessatorie (art. 1341 c.c. co. 2 — "doppia sottoscrizione")
 *  3. Informativa sul diritto di recesso di 14 giorni (artt. 52-59 Codice Consumo)
 *
 * I 3 consensi sono tutti OBBLIGATORI prima della conferma del pagamento.
 */
export default function CheckoutConsents({ values, onChange }) {
  const setField = (field, v) => onChange({ ...values, [field]: v });

  return (
    <div className="space-y-3" data-testid="checkout-consents">
      {/* 1. Termini e Condizioni */}
      <label className="flex items-start gap-3 p-3 bg-white border border-[#E5E2DB] rounded-xl cursor-pointer">
        <Checkbox
          checked={!!values?.termini}
          onCheckedChange={v => setField("termini", !!v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="checkout-termini-checkbox"
        />
        <div className="text-xs text-[#4A5E51] leading-relaxed">
          <span className="inline-flex items-center gap-1 font-semibold text-[#163321] mb-0.5">
            <ScrollText className="w-3.5 h-3.5" /> Accettazione Termini e Condizioni <span className="text-[#D97B58]">*</span>
          </span>
          <br />
          Dichiaro di aver letto e accettato integralmente i <Link to="/termini" target="_blank" className="underline text-[#163321]">Termini e Condizioni d'Uso</Link>, la <Link to="/privacy" target="_blank" className="underline text-[#163321]">Privacy Policy</Link> e la <Link to="/cookie-policy" target="_blank" className="underline text-[#163321]">Cookie Policy</Link>.
        </div>
      </label>

      {/* 2. Clausole vessatorie - doppia sottoscrizione art. 1341 c.c. co.2 */}
      <label className="flex items-start gap-3 p-3 bg-white border border-[#E5E2DB] rounded-xl cursor-pointer">
        <Checkbox
          checked={!!values?.clausole}
          onCheckedChange={v => setField("clausole", !!v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="checkout-clausole-checkbox"
        />
        <div className="text-xs text-[#4A5E51] leading-relaxed">
          <span className="inline-flex items-center gap-1 font-semibold text-[#163321] mb-0.5">
            <Gavel className="w-3.5 h-3.5" /> Approvazione specifica clausole vessatorie <span className="text-[#D97B58]">*</span>
          </span>
          <br />
          Approvo specificamente, ai sensi dell'art. 1341 comma 2 c.c., le seguenti clausole dei Termini d'Uso:
          <strong> art. 5</strong> (obblighi utente), <strong>art. 7</strong> (limitazione di responsabilità),
          <strong> art. 11</strong> (legge applicabile e foro competente), <strong>art. 12</strong> (facoltà di modifica unilaterale).
        </div>
      </label>

      {/* 3. Diritto di recesso 14 giorni */}
      <label className="flex items-start gap-3 p-3 bg-[#F5F4F0] rounded-xl cursor-pointer">
        <Checkbox
          checked={!!values?.recesso}
          onCheckedChange={v => setField("recesso", !!v)}
          className="mt-0.5 data-[state=checked]:bg-[#163321]"
          data-testid="checkout-recesso-checkbox"
        />
        <div className="text-xs text-[#4A5E51] leading-relaxed">
          <span className="inline-flex items-center gap-1 font-semibold text-[#163321] mb-0.5">
            <Clock className="w-3.5 h-3.5" /> Diritto di recesso e perdita del diritto <span className="text-[#D97B58]">*</span>
          </span>
          <br />
          Sono informato che, ai sensi degli <strong>artt. 52-59 del Codice del Consumo</strong> (D.Lgs. 206/2005), ho diritto a recedere dal
          contratto entro <strong>14 giorni</strong> dalla conclusione senza alcuna penale. Tuttavia, <strong>accetto espressamente che
          l'esecuzione del servizio di consulenza inizi prima del decorso del termine</strong> e, di conseguenza, riconosco di perdere il diritto
          di recesso una volta che la consulenza sia stata completamente erogata (art. 59 co. 1 lett. a Codice Consumo).
          Per esercitare il recesso prima dell'esecuzione: email a <a href="mailto:info@colucciassicuratori.com" className="text-[#163321] underline">info@colucciassicuratori.com</a>
          {" "}oppure utilizzare il <a href="https://www.agenziadoganemonopoli.gov.it/portale/documents/20182/8966550/Modulo+di+recesso+tipo.pdf" target="_blank" rel="noopener noreferrer" className="text-[#163321] underline">modulo di recesso standard</a>.
        </div>
      </label>
    </div>
  );
}
